<template>
  <div>
    <ProductionTabs tabName="DisplayCouverturesOnShelf"></ProductionTabs>
    <DisplayCouvertures title="Kuwertury"></DisplayCouvertures>
  </div>
</template>

<script>
import DisplayCouvertures from "./DisplayCouvertures";
import ProductionTabs from "./ProductionTabs";

export default {
  name: "DisplayCouverturesOnShelf",
  components: { DisplayCouvertures, ProductionTabs },
  computed: {},
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>